import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Menu, X } from "lucide-react";
import { motion } from "framer-motion";
const Navigation = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  const navItems = [{
    name: "Start",
    href: "/#hero"
  }, {
    name: "Über mich",
    href: "/#about"
  }, {
    name: "Leistungen",
    href: "/#services"
  }, {
    name: "Projekte",
    href: "/#projects"
  }, {
    name: "Referenzen",
    href: "/#testimonials"
  }, {
    name: "Kontakt",
    href: "/#contact"
  }];
  return <motion.nav 
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.6, ease: "easeOut" }}
      aria-label="Hauptnavigation"
      className={`fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-lg border-b transition-all duration-300 ${
        scrolled ? "border-border shadow-[var(--shadow-medium)]" : "border-transparent shadow-[var(--shadow-soft)]"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
            <motion.a 
              href="/#hero" 
              aria-label="Startseite" 
              className="flex items-center gap-3"
              whileHover={{ scale: 1.05 }}
              transition={{ duration: 0.2 }}
            >
              <img
                src="/lovable-uploads/577215ac-ab3f-4f5d-b337-701ad641df1c.png"
                alt="MA4Consult Logo"
                className="h-14 md:h-16 w-auto"
                loading="eager"
              />
              <span className="sr-only">MA4Consult</span>
            </motion.a>
          
          {/* Desktop Navigation */}
          <div className="hidden md:block">
            <div className="ml-10 flex items-baseline space-x-2">
              {navItems.map((item, index) => <motion.a 
                key={item.name} 
                href={item.href} 
                className="text-foreground hover:text-accent px-4 py-2 text-sm font-medium transition-[var(--transition-smooth)] relative group"
                initial={{ opacity: 0, y: -10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.3, delay: index * 0.05 }}
                whileHover={{ scale: 1.05 }}
              >
                {item.name}
                <span className="absolute bottom-0 left-4 right-4 h-0.5 bg-gradient-to-r from-accent to-purple-accent scale-x-0 group-hover:scale-x-100 transition-transform duration-300 origin-left"></span>
              </motion.a>)}
              <Button variant="cta" size="sm" className="ml-2" asChild>
                <a href="https://outlook.office365.com/book/Grndungsberatung@walbee.de/?ismsaljsauthenabled=true" target="_blank" rel="noopener noreferrer">
                  Zum Termin
                </a>
              </Button>
            </div>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <Button
              variant="ghost"
              size="icon"
              onClick={() => setIsOpen(!isOpen)}
              aria-label={isOpen ? "Menü schließen" : "Menü öffnen"}
              aria-expanded={isOpen}
              aria-controls="mobile-menu"
            >
              {isOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
            </Button>
          </div>
        </div>
      </div>

      {/* Mobile Navigation */}
      {isOpen && <div className="md:hidden" id="mobile-menu">
          <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3 bg-background border-b border-border">
            {navItems.map(item => <a key={item.name} href={item.href} className="text-foreground hover:text-primary block px-3 py-2 text-base font-medium" onClick={() => setIsOpen(false)}>
                {item.name}
              </a>)}
            <div className="px-3 py-2">
              <Button variant="cta" className="w-full" asChild>
                <a href="https://outlook.office365.com/book/Grndungsberatung@walbee.de/?ismsaljsauthenabled=true" target="_blank" rel="noopener noreferrer">
                  Zum Termin
                </a>
              </Button>
            </div>
          </div>
        </div>}
    </motion.nav>;
};
export default Navigation;